export enum DROPDOWN_TYPES {
	Menu = 'menu',
	Input = 'input'
}
